/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CsvTooManyErrorsLimitSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('CSV_TOO_MANY_ERRORS_LIMIT')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class CsvTooManyErrorsLimitSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CsvTooManyErrorsLimitSettingParser.decode(input).map(res => new CsvTooManyErrorsLimitSetting(res));
    }
    static unsafeDecode(input) {
        return CsvTooManyErrorsLimitSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CsvTooManyErrorsLimitSettingParser.encode(data);
    }
    static schema() {
        return CsvTooManyErrorsLimitSettingParser.schema();
    }
}
